import { render, staticRenderFns } from "./Maniglie.vue?vue&type=template&id=4cac17b6&"
import script from "./Maniglie.vue?vue&type=script&lang=js&"
export * from "./Maniglie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports